import { render, staticRenderFns } from "./forum_user.vue?vue&type=template&id=a75e2408&scoped=true&"
import script from "./forum_user.vue?vue&type=script&lang=js&"
export * from "./forum_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75e2408",
  null
  
)

export default component.exports